import { render } from "./SystemTab.vue?vue&type=template&id=589b9cde&scoped=true"
import script from "./SystemTab.vue?vue&type=script&lang=js"
export * from "./SystemTab.vue?vue&type=script&lang=js"

import "./SystemTab.vue?vue&type=style&index=0&id=589b9cde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-589b9cde"]])

export default __exports__